<template>
<nav class="surgical-nav">
    <div class="surgical-nav__content-wrapper">
        <div class="surgical-nav__logo">
            <div class="surgical-nav__logo--image">
                <img src="../../assets/images/iti-logo-plain.svg" alt="" />
            </div>
            <span>Surgical SAC assessment</span>
        </div>
        <div class="surgical-nav__close">
        <img src="../../assets/images/close.svg" alt="">
        </div>
    </div>
    <div class="surgical-nav__progress">
        <div class="surgical-nav__progress-fill" v-bind:style="this.style"></div>
    </div>
</nav>
</template>

<script>
export default {
    name: "UXModalNav",
    props: {
        width: String
    },
    computed: {
        style () {
            return 'width: ' + this.width + '%';
        }
    }
};
</script>
